import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Smooth scroll to the top of the page — the footer's "Back to the top"
// motion. Jumps instantly for visitors who prefer reduced motion.
export function scrollToTop() {
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top: 0, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
}

// Mounted once in PublicLayout: whenever the visitor moves to another page,
// bring them to the top of it with the same motion. Only the path counts,
// so switching tabs or filters within a page never moves the scroll.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  return null;
}
